import { memo, useCallback } from "react";
import ReactPaginate from "react-paginate";

import type { IPagination } from "./types";
import RightArrowIcon from "../../assets/icons/RightArrowIcon";
import LeftArrowIcon from "../../assets/icons/LeftArrowIcon";
import { PaginationContainer } from "./style";

export const Pagination = memo(({
  pageCount,
  changePage,
  pageSelected,
}: IPagination) => {
  const handlePageChange = useCallback((event: { selected: number }) => {
    if (changePage) {
      changePage(event.selected);
    }
  }, [changePage]);

  return (
    <PaginationContainer>
      <ReactPaginate
        className="paginator"
        nextLabel={<RightArrowIcon />}
        previousLabel={<LeftArrowIcon />}
        pageRangeDisplayed={3}
        pageCount={pageCount || 1}
        onPageChange={handlePageChange}
        forcePage={pageSelected || 0}
      />
    </PaginationContainer>
  );
});

Pagination.displayName = "Pagination";
